module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/pd-rating-d996446a2aa3d9de2bcd30d7815d3838.png";